import { useEffect } from "react";
import { Form, Input, Button, Row, Col, Tooltip } from "antd";
import { useSelector, useDispatch } from "react-redux";
import {
  changePassword,
  resetPasswordInfo,
} from "../../actionCreator/commonActionCreator";
import { getUserInfo } from "../../utils/utils";
import { getToken } from "../../utils/auth";
import { useAlert } from "../../context/AlertProvider";

const Info = () => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const userAccountInfo = getUserInfo();
  const updatePasswordInfo = useSelector(
    (state) => state?.CommonReducer?.updatePasswordInfo
  );

  useEffect(() => {
    if (userAccountInfo) {
      form.setFieldsValue({
        email: userAccountInfo?.email || "",
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      });
    }
  }, [userAccountInfo, form]);

  useEffect(() => {
    if (Object.keys(updatePasswordInfo).length) {
      form.resetFields();
      dispatch(resetPasswordInfo());
    }
  }, [updatePasswordInfo, form, dispatch]);

  const onFinish = async (values) => {
    const res = await dispatch(changePassword(getToken(), values));
    if (res?.status === 200) {
      showAlert("success", "Password has been updated successfully.");
    } else {
      showAlert("error", res?.response?.data?.title);
    }
  };

  return (
    <div
      style={{ marginLeft: 25, marginBottom: 25 }}
      className="errorformcontainer mt-3"
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label>Email</label>
          </Col>
          <Col xs={24} md={17}>
            <Tooltip title="Email update is not allowed!">
              <Form.Item
                name="email"
                className="mb15"
                rules={[
                  {
                    required: true,
                    message: "Please enter your email.",
                  },
                ]}
              >
                <Input readOnly className="common-input" />
              </Form.Item>
            </Tooltip>
          </Col>
        </Row>

        {/* Current Password */}
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label>Current Password</label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="currentPassword"
              className="mb15"
              rules={[
                {
                  required: true,
                  message: "Please enter current password.",
                },
              ]}
            >
              <Input.Password placeholder="Enter current password" />
            </Form.Item>
          </Col>
        </Row>

        {/* New Password */}
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label>New Password</label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="newPassword"
              className="mb15"
              dependencies={["currentPassword"]}
              rules={[
                {
                  required: true,
                  message: "Please enter new password.",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("currentPassword") !== value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(
                      new Error(
                        "New password must be different from current password"
                      )
                    );
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Enter current password" />
            </Form.Item>
          </Col>
        </Row>

        {/* Confirm Password */}
        <Row className="justify-content-between">
          <Col xs={24} md={6}>
            <label>
              Confirm Password<span className="text-error">*</span>
            </label>
          </Col>
          <Col xs={24} md={17}>
            <Form.Item
              name="confirmPassword"
              className="mb15"
              dependencies={["newPassword"]}
              rules={[
                {
                  required: true,
                  message: "Please enter confirm password.",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("newPassword") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match"));
                  },
                }),
              ]}
            >
              <Input.Password placeholder="Enter current password" />
            </Form.Item>
          </Col>
        </Row>

        <Row className="mt-3 mb-3 justify-content-end" gutter={16}>
          <Col>
            <Button
              onClick={() => {
                form.setFieldsValue({
                  email: userAccountInfo?.email || "",
                  currentPassword: "",
                  newPassword: "",
                  confirmPassword: "",
                });
              }}
            >
              Cancel
            </Button>
          </Col>
          <Col>
            <Button type="primary" className="theme-btn" htmlType="submit">
              Save
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default Info;
